import client from './client';

const testHarness = {
  enabled:              ()       => client.get('/test-harness/enabled/'),
  simulateAvailability: (body)   => client.post('/test-harness/simulate-availability/', body),
  simulateSwapPosts:    (body)   => client.post('/test-harness/simulate-swap-posts/',   body),
  simulateSwapClaims:   (body)   => client.post('/test-harness/simulate-swap-claims/',  body),
  reset:                (body)   => client.post('/test-harness/reset/', body),
};

export default testHarness;
